import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './CookieMessage.scss'
import { useCookies } from 'react-cookie'

export const CookieMessage = () => {
    const [cookies, setCookie] = useCookies(['hiddenMessage']);

    const clickClose = () => {
        console.log(setCookie('hiddenMessage', true, { path: '/' }));
        setCookie('hiddenMessage', true, { path: '/' });
    }
    useEffect(() => {
        console.log(cookies.hiddenMessage);
    }, [cookies]);
    return (
        <div className={cookies.hiddenMessage !== true ? 'cookie-message' : 'cookie-message hidden'}>
            {
                cookies.hiddenMessage !== true &&
                <div className="message">
                    <div className="title">
                        <p>POLÍTICA DE COOKIES</p>
                    </div>
                    <div className="text">
                        <p>Este sitio web únicamente utiliza cookies propias con finalidad técnica, no recaba ni cede datos de carácter personal de los usuarios sin su consentimiento. <Link to="/politica-de-cookies">Mas información</Link>.</p>
                    </div>
                    <div className="boton">
                        <button className="btn pointer" onClick={clickClose}>Aceptar</button>
                    </div>
                </div>
            }
        </div>
    )
}
